import handleSave from '@vindr/ui/src/components/Templates/actionSubmit';
import {
  useChangeOrderDevice,
  useGetDeviceStatisticsAll,
  useReceptOrder,
} from '@vindr/services/actions/order.action';
import { Checkbox, Form, Modal } from 'antd';
import { useGlobalState } from '../../contexts/GlobalContext';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QMSSelect from './QMSSelect';
import { useGetQMS, usePushQMS } from '@vindr/services/actions/qms.action';
import { QMS_Type, QMS_STATUS } from '@vindr/services/apis/qms.api';

const ReceiveQMS = ({
  open,
  onCancel,
  selectedRowKeys,
  setSelectedRowKeys,
  params,
}) => {
  const { t } = useTranslation('Vindoc');
  const { message } = useGlobalState();
  const [form] = Form.useForm();
  const defaultInstitution = useMemo(() => selectedRowKeys[0]?.institution_id, [selectedRowKeys]);
  const defaultDevice = useMemo(
    () =>
      selectedRowKeys.reduce(
        (acc, item) => (acc === item.device_id ? acc : null),
        selectedRowKeys[0]?.device_id
      ),
    [selectedRowKeys]
  );

  const qmsList = useGetQMS({
    institution_ids: [defaultInstitution],
    type: QMS_Type.DEVICE,
    status: QMS_STATUS.Active,
    enable_statistics: true,
  })?.data?.data || [];

  useEffect(() => {
    form.setFieldsValue({
      institution_id: defaultInstitution,
      order_ids: selectedRowKeys.map((item) => item.id),
      device_id: defaultDevice,
    });
  }, [open]);

  const { mutate: pushQMS, isLoading } = usePushQMS();

  const actionSave = () => {
    if (!form.getFieldValue('qms_id')) {
      message.error(t('Please select QMS'));
      return;
    }
    handleSave({
      message,
      form,
      type: 'create',
      mutate: { create: pushQMS },
      t,
      onDone: () => {
        onCancel();
        setSelectedRowKeys(() => []);
      },
      createParams: (values) => ({
        ...values,
        institution_id: selectedRowKeys?.[0]?.institution_id,
        order_ids: selectedRowKeys.map((item) => item.id),
      }),
      code: { created: 'SCD_34004' },
    });
  };

  return (
    <Modal
      className="w-[800px] max-w-[80vw]"
      open={open}
      maskClosable={false}
      centered
      onCancel={onCancel}
      destroyOnClose
      forceRender
      title={t('Receive QMS')}
      okText={t('Save')}
      confirmLoading={isLoading}
      onOk={form.submit}
    >
      <Form form={form} onFinish={actionSave} layout="vertical">
        {/* <FormItem.InstitutionList
          name="institution_id"
          label={t('Institution')}
          keyValue="id"
          multiple={false}
          disabled
          required
        /> */}
        <Form.Item name="qms_id" className="max-h-[70vh] overflow-y-scroll">
          <QMSSelect qmsList={qmsList} />
        </Form.Item>
        {/* <Form.Item name="should_merge_order" valuePropName="checked">
          <Checkbox checked={true}>{t('Merge Order With Same Patient')}</Checkbox>
        </Form.Item> */}
      </Form>
    </Modal>
  );
};

export default ReceiveQMS;
